import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';
import $ from 'jquery';

import { withUiBlock } from '@bingads-webui/uiblocker';
import { CampaignSelectorView } from '@bingads-webui-campaign-react/campaign-selector';
import { getAdgroupData } from '@bingads-webui-campaign-legacy/adgroup-create-advanced/view/adgroup-selector-repository';
import {
  isFilterSearchStandardAdgroupRecommendationType,
  ADGROUP_TYPES,
} from '@bingads-webui-campaign/recommendation-core';
import ViewModel from './ad-group-editor-model';
import template from './ad-group-editor.pug';

export class AdGroupEditorView extends Backbone.View {
  initialize({
    i18n,
    item,
    recommendationType,
    key,
    view,
    dataManager,
    isMCC = false,
    newPosition,
  }) {
    this.i18n = i18n;
    this.item = item;
    this.recommendationType = recommendationType;
    this.key = key;
    this.view = view;
    this.dataManager = dataManager;
    this.newPosition = newPosition;
    const defaultAdgroupId = item.Target.AdGroupId;
    const selectedAdgroupId = _.first(item.Opportunities).NewAdGroupId || defaultAdgroupId;
    this.defaultAdgroupId = defaultAdgroupId;
    this.defaultAdgroup = {
      Id: defaultAdgroupId,
      ID: defaultAdgroupId,
      name: item.Target.AdGroupName,
      status: 'Deleted',
    };
    this.selectedAdgroup = {
      Id: selectedAdgroupId,
      ID: selectedAdgroupId,
      name: _.first(item.Opportunities).Target.AdGroupName,
    };
    this.viewModel = new ViewModel({
      i18n,
      defaultAdgroupId,
      defaultAdgroup: this.defaultAdgroup,
      selectedAdgroupId,
    });
    this.isMCC = isMCC;
  }

  get events() {
    return {
      'click .save': 'save',
      'click .cancel': 'cancel',
    };
  }

  save() {
    const {
      key, view, item,
    } = this;

    const selectedAdgroup = this.viewModel.selectedAdgroup();

    // If no ad group is selected, it means the suggested ad group doesn't exist.
    if (_.isUndefined(selectedAdgroup)) { return; }

    // Update NewAdGroupId
    const selectedAdgroupId = Number(selectedAdgroup.id);
    _.first(item.Opportunities).AdGroupId = selectedAdgroupId;
    _.first(item.Opportunities).NewAdGroupId = selectedAdgroupId;

    // Update selected ad group name in grid.
    const selectedAdgroupName = this.viewModel.adgroups[selectedAdgroupId].name;
    _.first(item.Opportunities).Target.AdGroupName = selectedAdgroupName;

    const selectedKeys = view.grid.gridView.selectedKeys();
    // Append the current selected one into existing selected ones.
    if (!_.contains(selectedKeys, key)) {
      selectedKeys.push(key);
    }
    view.grid.gridView.set({ selection: _.defaults({ selected: selectedKeys }) });

    this.trigger('close');
  }

  cancel() {
    this.trigger('close');
  }

  fecthAdgroupData = ({
    query = '', pageNumber = 0, pageSize = 10, scopeParentItem = null,
  }, adgroupSelectorView) => {
    // eslint-disable-next-line no-param-reassign
    scopeParentItem = {
      Id: this.item.Target.CampaignId,
      AccountId: this.item.Target.AccountId,
    };
    let customFilter = 'DeliveryStatus ne \'AdGroupExpired\'';
    if (isFilterSearchStandardAdgroupRecommendationType(this.recommendationType)) {
      customFilter = customFilter.concat(` and AdGroupType eq '${ADGROUP_TYPES.SearchStandard}'`);
    }
    const uiBlockContainer = adgroupSelectorView && adgroupSelectorView.$('.dropdown-menu');
    return getAdgroupData('', 0, 10, scopeParentItem, `Id eq ${this.defaultAdgroupId}`)
      .then((defaultAdGroup) => {
        if (!_.isEmpty(defaultAdGroup.items)) {
          this.viewModel.defaultAdgroup.status = _.first(defaultAdGroup.items).status;
        }
        return getAdgroupData(query, pageNumber, pageSize, scopeParentItem, customFilter);
      })
      .then((adGroups) => {
        this.viewModel.totalCount = adGroups.totalCount;
        return _.map(
          adGroups.items,
          adGroup => _.extend(adGroup, { ID: adGroup.Id })
        );
      })
      .then(adGroups => _.object(_.map(adGroups, adGroup => adGroup.Id), adGroups))
      .then((adGroups) => {
        const adGroupsProcessed = this.viewModel.returnAdgroupIdInfoMapping(adGroups);
        return {
          items: adGroupsProcessed,
          totalCount: this.viewModel.totalCount,
        };
      })
      .finally(withUiBlock(uiBlockContainer));
  };

  onAdGroupSelect(selectedItem) {
    if (_.has(selectedItem, 'id')) {
      this.viewModel.selectedAdgroup(selectedItem);
    }
  }

  setPosition(selectorView) {
    const tableHeight = $('.recommendations-grid-view').outerHeight();
    const gridTopDistance = this.newPosition.top;
    const selectorDropdownSpace = (tableHeight - gridTopDistance);
    let top = 60;
    if (selectorDropdownSpace < 340) {
      top -= 340;
    }
    const position = {
      top,
      left: 10,
    };

    selectorView.$('.dropdown-menu').css(position);
  }

  render() {
    const {
      i18n,
    } = this;

    let selectorView = null;
    selectorView = new CampaignSelectorView({
      selectedItem: this.selectedAdgroup,
      fetch: args => this.fecthAdgroupData(args, selectorView),
      i18n,
      stringKeys: {
        emptyListContent: 'No results to display.',
        listHeader: 'Ad groups: {{itemCount}}',
        selectEntity: 'Select an ad group',
      },
      isToggled: true,
    }).render();

    selectorView.on('selected-campaign', (selectedItem) => {
      this.onAdGroupSelect(selectedItem);
    });

    this.$el.html(template({
      i18n,
    }));
    ko.applyBindings(this.viewModel, this.el);
    this.$('.new-campaign-adgroup-selector').append(selectorView.el);

    // dynamic render the overflow popup-selector
    this.setPosition(selectorView);

    return this;
  }
}
